import { loadUsers } from '../utils/storage';

// Función para obtener usuarios
export const getUsers = async () => {
  try {
    return await loadUsers();
  } catch (error) {
    console.error('Error cargando usuarios:', error);
    return [];
  }
};

// Células disponibles
export const availableCells = [
  'C1GA', 'C2GA', 'C3GA', 'C4GA', 'C5GA', 'C6GA',
  'C1MA', 'C2MA', 'C3MA', 'C4MA',
  'G1M1', 'G1M2', 'G1M3', 'G1M4',
  'G2M1', 'G2M2', 'G2M3', 'G2M4',
  'G3M1', 'G3M2', 'G3M3', 'G3M4',
  'G4M1', 'G4M2', 'G4M3', 'G4M4',
  'G5M1', 'G5M2', 'G5M3', 'G5M4',
  'G6M1', 'G6M2', 'G6M3', 'G6M4'
];
